import { useTranslation } from "react-i18next";
import useAppSelector from "../../../../../../hooks/redux/base/useAppSelector";
import useStepSpecific from "../../../../../../hooks/useStepSpecific";
import { baseEndpointPaths } from "../../../../../../services/serviceCalls";
import {
  completePublicAccessStep,
  setStepePublicAccessEdited,
} from "../../../../../../store/redux/slice/Forms/publicAccessForm";
import { initialSuggestionDetails } from "../../../../../../init/suggestionInitialValues";
import useFormReset from "../../../../../../hooks/useFormReset";
import { ApplicationSubtype, BoxSpg, DividerSpg } from "@duosoftbg/nacid-components";
import { FormProvider } from "react-hook-form";
import { toast } from "react-toastify";
import { Button, Typography } from "@mui/material";
import { createPublicAccessDetailsValidationSchema } from "../../../../../../yup/publicAccess/publicAccessValidationSchemas";
import PublicAccessDetailsSection from "./section/PublicAccessDetailsSection";
import { createFormalValidationFromSchema } from "../../../../../../yup/utils/yupUtils";
import useStepSpecificValidation from "../../../../../../hooks/useStepSpecificValidation";
import PartialFormDataDialog from "../../../common/form/validation/PartialFormDataDialog";
import React from "react";

const PublicAccessStepPublicAccess = () => {
  const { t } = useTranslation();

  const publicAcessForm = useAppSelector((state) => {
    return state.Forms.PublicAccessForm;
  });

  const fullSchema = createPublicAccessDetailsValidationSchema;
  const formalSchema = createFormalValidationFromSchema(fullSchema);

  const { onSubmit, methods } = useStepSpecific(
    publicAcessForm.publicAccessDetails,
    publicAcessForm.id,
    baseEndpointPaths.publicAccess,
    formalSchema,
    setStepePublicAccessEdited,
    completePublicAccessStep,
    initialSuggestionDetails,
  );

  const { onSubmitWithValidations, handleCancel, handleAccept, showModal } = useStepSpecificValidation(
    fullSchema,
    formalSchema,
    methods,
    onSubmit,
  );

  useFormReset(ApplicationSubtype.PUBLIC_ACCESS, publicAcessForm.publicAccessDetails, methods.reset);

  return (
    <BoxSpg>
      <FormProvider {...methods}>
        <form
          onSubmit={methods.handleSubmit(onSubmitWithValidations, (errors) => {
            toast.error(t("m.validation.errors.present"));
            console.log(errors);
          })}
        >
          <PublicAccessDetailsSection />
          <DividerSpg my={4} />
          <BoxSpg>
            <Typography align={"left"}>
              <Button type={"submit"} variant={"contained"}>
                {t("l.btn.saveData")}
              </Button>
            </Typography>
          </BoxSpg>
        </form>
      </FormProvider>
      <PartialFormDataDialog open={showModal} handleCancel={handleCancel} handleAccept={handleAccept} />
    </BoxSpg>
  );
};
export default PublicAccessStepPublicAccess;
